import { render, staticRenderFns } from "./NpsmList.vue?vue&type=template&id=22e83168&scoped=true&"
import script from "./NpsmList.vue?vue&type=script&lang=js&"
export * from "./NpsmList.vue?vue&type=script&lang=js&"
import style0 from "./NpsmList.vue?vue&type=style&index=0&id=22e83168&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e83168",
  null
  
)

export default component.exports